import { render, staticRenderFns } from "./sales_num.vue?vue&type=template&id=b52795c4&scoped=true&"
import script from "./sales_num.vue?vue&type=script&lang=js&"
export * from "./sales_num.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52795c4",
  null
  
)

export default component.exports